import React, {useState} from 'react';
import { BrowserRouter as Router, Route, Routes, Link, useLocation } from 'react-router-dom';
import {Tabs, Tab, useMediaQuery} from '@mui/material';
import App from './App';
import GlobalSoundSetting from './GlobalSoundSetting';
import SavePatch from './SavePatch';
import LoadPatch from "./LoadPatch";
import VersionLabel from "./VersionLabel";
import MidiInterfaceLoader from "./MidiInterfaceLoader";
import {MidiAccessStatus} from "./utils";

function NavigationTabs() {
    const location = useLocation();
    const value = location.pathname === '/'
        ? 0
        : location.pathname === '/global_setting'
            ? 1
            : location.pathname === '/save_patch'
                ? 2
                : location.pathname === '/load_patch'
                    ? 3
                    : false;

    return (
        <Tabs value={value}>
            <Tab label="切り替えリスト" component={Link} to="/" />
            <Tab sx={{ textTransform: 'none' }} label="Global Sound Setting" component={Link} to="/global_setting" />
            <Tab label="パッチデータ読み込み保存" component={Link} to="/save_patch" />
            <Tab label="パッチデータ書き込み" component={Link} to="/load_patch" />
        </Tabs>
    );
}

export default　function MyRoute() {
    const [midiOutputs, setMidiOutputs] = useState([]);
    const [midiInputs, setMidiInputs] = useState([]);
    const [midiAccessStatus, setMidiAccessStatus] = useState(MidiAccessStatus.initializing);
    const isSmallScreen = useMediaQuery('(max-width:700px)');
    return (
        <>
            <MidiInterfaceLoader setMidiOutputs={setMidiOutputs} setMidiInputs={setMidiInputs} midiOutputs={midiOutputs} midiInputs={midiInputs} setSMidiAccessStatus={setMidiAccessStatus} />
                <Router>
                    {!isSmallScreen &&
                        <>
                            <NavigationTabs />
                            <VersionLabel />
                        </>
                    }
                    <Routes>
                        <Route path="/" element={<App midiOutputs={midiOutputs} midiInputs={midiInputs} midiAccessStatus={midiAccessStatus}/>} />
                        <Route path="/global_setting" element={<GlobalSoundSetting midiOutputs={midiOutputs}/>} />
                        <Route path="/save_patch" element={<SavePatch midiOutputs={midiOutputs} midiInputs={midiInputs}/>} />
                        <Route path="/load_patch" element={<LoadPatch midiOutputs={midiOutputs}/>} />
                    </Routes>
                </Router>

        </>
    );
}
